import React from 'react';
import WHATSAPP from 'assets/icons/whatsapp.svg';
import PHONE from 'assets/icons/phone.svg';

import styles from './support.module.scss';

function Support() {
    const logoResize =
        window.screen.width / 1400 > 1 ? 1 : window.screen.width / 1400;

    return (
        <div
            className={styles.wrapper}
            style={{ transform: `scale(${logoResize})` }}
        >
            <p className={styles.text}>official support</p>
            <a
                data-testid="whatsapp"
                href="whatsapp://send?text=Some text goes here"
                data-action="share/whatsapp/share"
                target="_blank"
                rel="noopener noreferrer"
            >
                {' '}
                <img src={WHATSAPP} alt="whatsapp" />{' '}
            </a>
            <a data-testid="phone" href="tel:9515918848">
                {' '}
                <img src={PHONE} alt="phone" />
            </a>
        </div>
    );
}

export default Support;
